export function getSafeOrigin(url) {
	try {
		return new URL(url).origin;
	} catch (err) {
		return null;
	}
}

export function addPreconnect(origin) {
	if (!origin) return;
	if (document.querySelector(`link[rel="preconnect"][href="${origin}"]`)) return;

	const link = document.createElement('link');
	link.rel = 'preconnect';
	link.href = origin;
	document.head.appendChild(link);
}

export function addPreload(href, as) {
	if (!href) return;
	if (document.querySelector(`link[rel="preload"][href="${href}"]`)) return;

	const link = document.createElement('link');
	link.rel = 'preload';
	link.href = href;
	link.as = as;
	document.head.appendChild(link);
}
